import counter from "../utils/counter-utils";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { tempkeyCounter } from "./frfr-draftel-counter-utils";
import { virbomDetectLastSubkey } from "../utils/frfr-virbom-utils";
import { terUtilsSelectKlimaKomoraBySubkey, terUtilsSelectModulBySubkey, terUtilsSelectModulWhere } from "./ter-selectors";
// import { _datarender_vr_draft_by_draftel_arr, _update_virtelArr_with_genus_ident } from "./ter-virtel-datarender-by-draftel-arr"; // OBSOLETE
import { COMMA } from "../utils/frfr-string-consts";
// import { draftel_arr_utils_delete_item_and_all_descendants, draftel_arr_utils_item_update } from "../utils/frfr-draftel-arr-utils"; // OBSOLETE
import { _draftel_codecs_datarender_virbom_from_single_draftel, _terkk_convert_virbom_seq_to_draftel_arr_and_smartbom } from "./ter-draftel-codec-lib";
import { js_utils } from "../utils/frfr-js-utils";
import { _smartbom_manipulator_add_draftel, _smartbom_manipulator_delete_draftel, _smartbom_manipulator_detect_last_subkey, _smartbom_manipulator_get_draftel_single_by_subkey, _smartbom_manipulator_init_make_smartbom, _smartbom_manipulator_update_draftel, _smartbom_manipulator_update_draftel_enabled, _smartbom_manipulator_update_refresh_all, _smartbom_manipulator_upsert_self_property, _smartbom_validator_quick_incomplete } from "../utils/frfr-smartbom-utils";
import { terUtilsSortirajDrafteleKonzistentnimRedosledom } from "./ter-redosled-utils";
import { _datarender_virbom_from_smartbom } from "./ter-virbom-datarender";
import { _make_sastavnica_internal_from_virbom_seq } from "./ter-export-lib-sastavnica-21r3";
import { _compatibility_fix_sastavnica_internal, _compatibility_fix_smartbom } from "./ter-compatibility-utils";
import { terUtils_make_smartbom_blank_latest, terUtils_make_smartbom_manifest_terkk_latest } from "./ter-smartbom-utils";
import { _getTerkkCparamsDefaultFromLib } from "./ter-params-utils";


/*
DOKUMNENTACIJA:

ter-reactive-utils.js
Funkcije inspirisane reaktivnim programiranjem. Svaka od njih vrsi neke izmene na jednom elementu i svim ostalima koji su hijerarhijski potcinjeni (zavisni ili subscribeovani) njemu.

HELPERI (sufix Helper) su u stvari REDUCER HELPERI i oni su zapravo izdvojeni deo reducera koji prima i vraca ceo state.
Ostale funkcije obavljaju CRUD operacije ali ne znaju za ceo state nego samo za podatke koji su njihova briga.
*/


export const terUtilsDraftDetectMaxSubkey = (arr, arr2, smartbom) => {
  //export const terUtilsDraftDetectMaxSubkey = (draft) => {
  // NOVO detect MaxSubkey za kompletan draft...
  // let x = virbomCounter.generateFreshSubkey();
  let x = 0;
  if (Array.isArray(arr)) {
    let virtelMaxSubkey = virbomDetectLastSubkey(arr);
    console.log(virtelMaxSubkey);
    if (virtelMaxSubkey > x) {
      x = virtelMaxSubkey + 1;
      x = virtelMaxSubkey;
    }
  }
  if (Array.isArray(arr2)) {
    let virtelMaxSubkey2 = virbomDetectLastSubkey(arr2);
    console.log(virtelMaxSubkey2);
    if (virtelMaxSubkey2 > x) {
      x = virtelMaxSubkey2;
    }
  }
  if (_smartbom_validator_quick_incomplete(smartbom)) {
    let smartbomMaxSubkey3 = _smartbom_manipulator_detect_last_subkey(smartbom);
    console.log(smartbomMaxSubkey3);
    if (smartbomMaxSubkey3 > x) {
      x = smartbomMaxSubkey3;
    }
  }
  // virbomCounter.updateSmart(x);
  console.log(x);
  return x; // return maxsubkey
};


// LOAD/SAVE DRAFT

export const terUtilsDraftAfterSaveToDatabaseSuccessHelper = (state, action) => {
  const virbom = action.payload.response_payload;
  let db_virbom_header = false;
  let db_virbom_seq = [];
  if (virbom) {
    if (virbom.virbom_header === false) {
      // nema nista scuvano na backendu. tretiramo kao prazan blank virbom
      db_virbom_header = false;
      db_virbom_seq = [];
    } else if (virbom && js_utils.is_object(virbom.virbom_header)) {
      db_virbom_header = {
        ...virbom.virbom_header
      };
      if (virbom && Array.isArray(virbom.virbom_members)) {
        db_virbom_seq = virbom.virbom_members;
      }
    }
  }
  // ucitava samo sekundarni (obogacen sa IDENT-ima) virtuelni draft
  // const vr_draft = action.payload.vr_draft;
  const virtel_subkey_plus_genus_ident_arr = action.payload.virtel_subkey_plus_genus_ident_arr; // NOVO DECEMBAR
  const virtel_with_genus_ident_arr = action.payload.virtel_with_genus_ident_arr;
  let newDraft = {
    ...state,
    virbom_header: db_virbom_header,
    virbom_header_db: db_virbom_header,
    virtel_subkey_plus_genus_ident_arr: virtel_subkey_plus_genus_ident_arr,
    virtel_with_genus_ident_arr: virtel_with_genus_ident_arr,
    db_virbom_seq: db_virbom_seq,
    saved: true,
    saving: false,
    freshness: counter.getFreshInteger()
  };
  return {
    ...newDraft
  };
};


export const terUtilsDraftUnloadHelper = (initialState) => {
  virbomCounter.resetCounter();
  return {
    ...initialState,
    freshness: counter.getFreshInteger()
  };
};


export const terUtilsDraftLoadBlankHelper = (initialState) => {
  virbomCounter.resetCounter();
  return {
    ...initialState,
    loaded: true,
    freshness: counter.getFreshInteger()
  };
};


export const terUtilsDraftLoadImportedSmartbomFromCapsule = (state, smartbom) => {
  //
  console.log('terUtilsDraftLoadImportedSmartbomFromCapsule(state, smartbom)');
  let newDraft = {
    ...state,
    virbom_header: false, // da se ponosti virbom_rev_id
    smartbom: smartbom,
    loaded: true,
    saved: false,
    freshness: counter.getFreshInteger()
  };
  const virbom_seq = _datarender_virbom_from_smartbom(smartbom); // NOVO 2023 MAJ
  const sastavnica_internal = _make_sastavnica_internal_from_virbom_seq(virbom_seq, null);
  //
  // STEP priprema countera
  virbomCounter.resetCounter(); // RESET COUNTER
  const maxSubkey = terUtilsDraftDetectMaxSubkey(virbom_seq, null, smartbom); // maxSubkey je potreban samo pri ucitavanju drafta
  virbomCounter.updateSmart(maxSubkey);
  //
  return {
    ...newDraft,
    virbom_seq,
    sastavnica_internal
  };
};


export const terUtilsDraftRefreshSmartbom = (state) => {
  console.log('terUtilsDraftRefreshSmartbom(state)');
  //
  // STEP refresh smartbom
  const refreshed_smartbom = _smartbom_manipulator_update_refresh_all(state.smartbom, _draftel_codecs_datarender_virbom_from_single_draftel);
  // STEP calculate oall by refreshed smartbom
  const virbom_seq = _datarender_virbom_from_smartbom(refreshed_smartbom); // NOVO 2023 MAJ
  const sastavnica_internal = _make_sastavnica_internal_from_virbom_seq(virbom_seq, null);
  //
  // STEP priprema countera
  virbomCounter.resetCounter(); // RESET COUNTER
  const maxSubkey = terUtilsDraftDetectMaxSubkey(virbom_seq, null, refreshed_smartbom); // maxSubkey je potreban samo pri ucitavanju drafta
  virbomCounter.updateSmart(maxSubkey);
  //
  return {
    ...state,
    virbom_header: false, // da se ponosti virbom_rev_id
    smartbom: refreshed_smartbom,
    virbom_seq,
    sastavnica_internal,
    saved: false,
    freshness: counter.getFreshInteger()
  };
};


export const terUtilsDraftLoadVersion1Helper = (state, resbox) => {
  // CASE virbom_resbox version 1 OLD
  // novo 2021april
  console.log('-----UCITAVANJE U DRAFT. iz baze virbom version 1 - virbom_resbox: ', resbox);
  // TODO: treba da izvuce od virtela sa backenda one koji imaju ____ i da njih upise u draftel_arr 
  // ucitava virbom iz baze u draft state
  let virbom_rev_id = null;
  let virbom_header_db = false;
  let db_virbom_header = false;
  let db_virbom_seq = [];
  if (resbox.virbom_resbox_error && resbox.virbom_is_blank) {
    // nema nista scuvano na backendu. tretiramo kao prazan blank virbom
    db_virbom_header = false;
    virbom_header_db = false; // virbom_header_db false znaci da nema ni jedna sacuvana revizija u bazi
    db_virbom_seq = [];
  } else {
    if (resbox && js_utils.is_object(resbox.virbom_header) && resbox.virbom_header.id > 0) {
      virbom_rev_id = resbox.virbom_header.id;
      db_virbom_header = {
        ...resbox.virbom_header
      };
      virbom_header_db = { // takodje cuvamo virbom_header_db
        ...resbox.virbom_header
      };
      if (resbox && Array.isArray(resbox.virbom_seq)) {
        db_virbom_seq = resbox.virbom_seq;
      }
    }
  }
  // STEP priprema countera
  virbomCounter.resetCounter(); // RESET COUNTER
  const maxSubkey = terUtilsDraftDetectMaxSubkey(db_virbom_seq, null, null); // maxSubkey je potreban samo pri ucitavanju drafta
  virbomCounter.updateSmart(maxSubkey);
  //
  //const _draftel_arr = _terkk_convert_virbom_seq_to_draftel_arr_and_smartbom(db_virbom_seq, virbomCounter.generateFreshSubkey, tempkeyCounter.generateFreshTempkey);
  const {
    _draftel_arr,
    smartbom
  } = _terkk_convert_virbom_seq_to_draftel_arr_and_smartbom(db_virbom_seq, virbomCounter.generateFreshSubkey, tempkeyCounter.generateFreshTempkey);
  console.log('**** db_virbom_seq CONVERTED TO _draftel_arr - _draftel_arr', _draftel_arr);
  console.log('**** db_virbom_seq CONVERTED TO smartbom - smartbom', smartbom);
  // console.log('_draftel_arr');
  // console.log(_draftel_arr);
  //
  let newDraft = {
    ...state,
    virbom_header: db_virbom_header,
    virbom_header_db,
    smartbom,
    draftel_arr: _draftel_arr,
    loaded: true,
    saved: true,
    db_virbom_seq,
    freshness: counter.getFreshInteger()
  };
  const virbom_seq = _datarender_virbom_from_smartbom(smartbom); // NOVO 2023 MAJ
  const sastavnica_internal = _make_sastavnica_internal_from_virbom_seq(virbom_seq, virbom_rev_id);
  return {
    ...newDraft,
    virbom_seq,
    sastavnica_internal
  };
};


export const terUtilsDraftLoadHelper_virbom_is_blank = (state, resbox) => {
  // CASE virbom_resbox version 2
  console.log('-----UCITAVANJE U DRAFT. iz baze WITHOUT VIRBOM - virbom_resbox virbom_is_blank!!!: ', resbox);
  // TODO: treba da izvuce od virtela sa backenda one koji imaju ____ i da njih upise u draftel_arr 
  // ucitava virbom iz baze u draft state
  let virbom_rev_id = null;
  let virbom_header_db = false;
  let db_virbom_header = false;
  let db_virbom_seq = [];
  let smartbom;
  let sastavnica_internal = [];
  // if (resbox.virbom_resbox_error && resbox.virbom_is_blank) {
  if (resbox.virbom_is_blank) {
    // nema nista scuvano na backendu. tretiramo kao prazan blank virbom
    console.log('resbox.virbom_is_blank', resbox.virbom_is_blank);
    db_virbom_header = false;
    virbom_header_db = false; // virbom_header_db false znaci da nema ni jedna sacuvana revizija u bazi
    db_virbom_seq = [];
    /*
    const default_smartbom_cparams = _getTerkkCparamsDefaultFromLib();
    smartbom = _smartbom_manipulator_init_make_smartbom(terUtils_make_smartbom_manifest_terkk_latest(), default_smartbom_cparams);
    */
    smartbom = terUtils_make_smartbom_blank_latest();
  } else {

  }
  //
  // kod version 2 se ne vrse nikakve konverzije samo reset countera
  //
  // STEP priprema countera
  virbomCounter.resetCounter(); // RESET COUNTER
  const maxSubkey = terUtilsDraftDetectMaxSubkey(db_virbom_seq, null, smartbom); // maxSubkey je potreban samo pri ucitavanju drafta
  virbomCounter.updateSmart(maxSubkey);
  //
  let newDraft = {
    ...state,
    virbom_header: db_virbom_header,
    virbom_header_db,
    smartbom,
    virbom_seq: [...db_virbom_seq],
    sastavnica_internal,
    draftel_arr: [], // TODO
    loaded: true,
    saved: true,
    db_virbom_seq,
    freshness: counter.getFreshInteger()
  };
  // const virbom_seq = _datarender_virbom_from_smartbom(smartbom); // NOVO 2023 MAJ
  return {
    ...newDraft,
    // virbom_seq
  };
};


export const terUtilsDraftLoadVersion2Helper = (state, resbox) => {
  // CASE virbom_resbox version 2
  console.log('-----UCITAVANJE U DRAFT. iz baze virbom version 2 - virbom_resbox: ', resbox);
  // TODO: treba da izvuce od virtela sa backenda one koji imaju ____ i da njih upise u draftel_arr 
  // ucitava virbom iz baze u draft state
  let virbom_rev_id = null;
  let virbom_header_db = false;
  let db_virbom_header = false;
  let db_virbom_seq = [];
  let smartbom;
  let sastavnica_internal = [];
  if (resbox.virbom_resbox_error && resbox.virbom_is_blank) {
    // nema nista scuvano na backendu. tretiramo kao prazan blank virbom
    console.log('resbox.virbom_is_blank', resbox.virbom_is_blank);
    db_virbom_header = false;
    virbom_header_db = false; // virbom_header_db false znaci da nema ni jedna sacuvana revizija u bazi
    db_virbom_seq = [];
    // STEP prazan virbom_resbox automatski konvertujemo da postane novi prazan smartbom najnovija verzija sa najnovijim cparams default.
    /*
    const default_smartbom_cparams = _getTerkkCparamsDefaultFromLib();
    smartbom = _smartbom_manipulator_init_make_smartbom(terUtils_make_smartbom_manifest_terkk_latest(), default_smartbom_cparams);
    */
    smartbom = terUtils_make_smartbom_blank_latest();
  } else {
    if (resbox && js_utils.is_object(resbox.virbom_header)) {
      virbom_rev_id = resbox.virbom_header.id;
      db_virbom_header = {
        ...resbox.virbom_header
      };
      virbom_header_db = { // takodje cuvamo virbom_header_db
        ...resbox.virbom_header
      };
      if (resbox && Array.isArray(resbox.virbom_seq)) {
        db_virbom_seq = resbox.virbom_seq;
      }
      if (resbox && _smartbom_validator_quick_incomplete(resbox.smartbom)) {
        smartbom = _compatibility_fix_smartbom(resbox.smartbom, "2");
      }
      if (resbox && Array.isArray(resbox.sastavnica_internal)) {
        // sastavnica_internal = resbox.sastavnica_internal;
        sastavnica_internal = _compatibility_fix_sastavnica_internal(resbox.sastavnica_internal, virbom_rev_id);
      }
    }
  }
  //
  // kod version 2 se ne vrse nikakve konverzije samo reset countera
  //
  // STEP priprema countera
  virbomCounter.resetCounter(); // RESET COUNTER
  const maxSubkey = terUtilsDraftDetectMaxSubkey(db_virbom_seq, null, smartbom); // maxSubkey je potreban samo pri ucitavanju drafta
  virbomCounter.updateSmart(maxSubkey);
  //
  let newDraft = {
    ...state,
    virbom_header: db_virbom_header,
    virbom_header_db,
    smartbom,
    virbom_seq: [...db_virbom_seq],
    sastavnica_internal,
    draftel_arr: [], // TODO
    loaded: true,
    saved: true,
    db_virbom_seq,
    freshness: counter.getFreshInteger()
  };
  // const virbom_seq = _datarender_virbom_from_smartbom(smartbom); // NOVO 2023 MAJ
  return {
    ...newDraft,
    // virbom_seq
  };
};


// DELETE

export const terUtilsDeleteDraftelHelper = (state, subkey) => {
  // REDUCER HELPER - TREBA PAZITI DA BUDE PURE I SVI UTILS...
  return {
    ...state,
    smartbom: _smartbom_manipulator_delete_draftel(state.smartbom, subkey),
    // draftel_arr: draftel_arr_utils_delete_item_and_all_descendants(state.draftel_arr, subkey),
    saved: false,
    virbom_header: false,
    virtel_with_genus_ident_arr: null,
    freshness: counter.getFreshInteger()
  };
};


// CREATE

const _create_draftel_entity = (entbox, parent_subkey) => {
  let newDraftel = {
    ...entbox,
    subkey: virbomCounter.generateFreshSubkey(), // ENRICH with fresh subkey
    parent_subkey: parent_subkey // enrich with parent_subkey
  };
  return newDraftel;
};


const _create_draftel_terkk$klimakomora_entity = (entbox, parent_subkey) => {
  let _parent_subkey = null;
  // if (typeof parent_subkey == 'string' || typeof parent_subkey == 'number') {
  if (typeof parent_subkey === 'number' && parent_subkey > 0) {
    _parent_subkey = parent_subkey;
  }
  let newDraftelKlimaKomora = {
    ...entbox,
    pozicijemodula: terUtilsPozicijeModulaCreateSveBlank(),
    subkey: virbomCounter.generateFreshSubkey(),
    parent_subkey: _parent_subkey
  };
  return newDraftelKlimaKomora;
};


export const terUtilsCreateKlimaKomoraHelper = (state, entbox, parent_subkey, wizardMode, wizardOperationFreshness) => {
  // REDUCER HELPER - TREBA PAZITI DA BUDE PURE I SVI UTILS...
  let newDraftel = _create_draftel_terkk$klimakomora_entity(entbox, parent_subkey);
  // TODO dodati da u wizard modu ostavlja u state-u trag koji subkey je poslednji dodat putem wizarda
  let wizardInfo = {
    operationFreshness: wizardOperationFreshness,
    operationCreatedId: false,
    what: 'KLIMAKOMORA'
  };
  if (wizardMode === true) {
    // ukoliko je element dodat u wizard modu, njegov subkey se belezi u draft state kako bi wizard mogao da ga koristi za sledece korake
    wizardInfo.operationCreatedId = newDraftel.subkey;
  }
  return {
    ...state,
    smartbom: _smartbom_manipulator_add_draftel(state.smartbom, newDraftel, null, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel),
    draftel_arr: [...state.draftel_arr, newDraftel],
    saved: false,
    virbom_header: false,
    virtel_with_genus_ident_arr: null,
    wizardInfo: wizardInfo,
    freshness: counter.getFreshInteger()
  };
};


export const terUtilsCreateModulHelper = (state, entbox, parent_subkey, wizardMode, wizardOperationFreshness) => {
  // REDUCER HELPER - TREBA PAZITI DA BUDE PURE I SVI UTILS...
  let newDraftel = _create_draftel_entity(entbox, parent_subkey);

  //
  let wizardInfo = {
    operationFreshness: wizardOperationFreshness,
    operationCreatedId: false,
    what: 'MODUL'
  };
  if (wizardMode === true) {
    // ukoliko je element dodat u wizard modu, njegov subkey se belezi u draft state kako bi wizard mogao da ga koristi za sledece korake
    wizardInfo.operationCreatedId = newDraftel.subkey;
  }

  return {
    ...state,
    smartbom: _smartbom_manipulator_add_draftel(state.smartbom, newDraftel, parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel),
    // draftel_arr: [..._draftel_arr1, newDraftel],
    draftel_arr: [...state.draftel_arr, newDraftel],
    saved: false,
    virbom_header: false,
    virtel_with_genus_ident_arr: null,
    wizardInfo: wizardInfo,
    freshness: counter.getFreshInteger()
  };
};


export const terUtilsCreatePoluproizvodHelper = (state, entbox, parent_subkey, wizardMode, wizardOperationFreshness) => {
  // REDUCER HELPER - TREBA PAZITI DA BUDE PURE I SVI UTILS...
  let newDraftel = _create_draftel_entity(entbox, parent_subkey);

  let wizardInfo = {
    operationFreshness: wizardOperationFreshness,
    operationCreatedId: false,
    what: 'PANEL'
  };
  if (wizardMode === true) {
    // ukoliko je element dodat u wizard modu, njegov subkey se belezi u draft state kako bi wizard mogao da ga koristi za sledece korake
    wizardInfo.operationCreatedId = newDraftel.subkey;
  }

  return {
    ...state,
    smartbom: _smartbom_manipulator_add_draftel(state.smartbom, newDraftel, parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel),
    draftel_arr: [...state.draftel_arr, newDraftel],
    saved: false,
    virbom_header: false,
    virtel_with_genus_ident_arr: null,
    wizardInfo: wizardInfo,
    freshness: counter.getFreshInteger()
  };
};


export const terUtilsCreateMaterijalCustomHelper = (state, entbox, parent_subkey, wizardMode, wizardOperationFreshness) => {
  // REDUCER HELPER - TREBA PAZITI DA BUDE PURE I SVI UTILS...
  let newDraftel = _create_draftel_entity(entbox, parent_subkey);

  let wizardInfo = {
    operationFreshness: wizardOperationFreshness,
    operationCreatedId: false,
    what: 'MATERIJALCUSTOM'
  };
  if (wizardMode === true) {
    // ukoliko je element dodat u wizard modu, njegov subkey se belezi u draft state kako bi wizard mogao da ga koristi za sledece korake
    wizardInfo.operationCreatedId = newDraftel.subkey;
  }

  return {
    ...state,
    smartbom: _smartbom_manipulator_add_draftel(state.smartbom, newDraftel, parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel),
    draftel_arr: [...state.draftel_arr, newDraftel],
    saved: false,
    virbom_header: false,
    virtel_with_genus_ident_arr: null,
    wizardInfo: wizardInfo,
    freshness: counter.getFreshInteger()
  };
};


export const terUtilsCreateMaterijalCustomBulkHelper = (state, entbox_bulk, parent_subkey) => {
  // REDUCER HELPER - TREBA PAZITI DA BUDE PURE I SVI UTILS...
  let _smartbom = js_utils.pure_clone_by_json(state.smartbom);
  let draftel_arr; // TODO
  if (Array.isArray(entbox_bulk)) {
    entbox_bulk.forEach((entbox) => {
      let newDraftel = _create_draftel_entity(entbox, parent_subkey);
      _smartbom = _smartbom_manipulator_add_draftel(_smartbom, newDraftel, parent_subkey, terUtilsSortirajDrafteleKonzistentnimRedosledom, _draftel_codecs_datarender_virbom_from_single_draftel);
    });
  }

  return {
    ...state,
    smartbom: _smartbom,
    // draftel_arr: [...state.draftel_arr, newDraftel], // TODO
    saved: false,
    virbom_header: false,
    virtel_with_genus_ident_arr: null,
    // wizardInfo: wizardInfo,
    freshness: counter.getFreshInteger()
  };
};


// UPDATE

export const terUtilsUpdateKlimaKomoraHelper = (state, entbox, subkey) => {
  // REDUCER HELPER - TREBA PAZITI DA BUDE PURE I SVI UTILS...
  let editedDraftel = {
    ...entbox,
    subkey: subkey
  }
  return {
    ...state,
    smartbom: _smartbom_manipulator_update_draftel(state.smartbom, subkey, editedDraftel, _draftel_codecs_datarender_virbom_from_single_draftel),
    // draftel_arr: draftel_arr_utils_item_update(state.draftel_arr, subkey, editedDraftel),
    saved: false,
    virbom_header: false,
    virtel_with_genus_ident_arr: null,
    freshness: counter.getFreshInteger()
  };
};

// export const terUtilsUpdateModulHelper = (state, entbox, subkey) => {
export const terUtilsUpdateModulHelper = (state, entbox, subkey, wizardMode, wizardOperationFreshness) => {
  // REDUCER HELPER - TREBA PAZITI DA BUDE PURE I SVI UTILS...
  let editedDraftel = {
    ...entbox,
    subkey: subkey
  };
  const freshness = counter.getFreshInteger();
  // provera da li su dimenzije izmenjene
  let zaSupervalidatorDimenzijeModulaIzmenjene = state.zaSupervalidatorDimenzijeModulaIzmenjene;
  let dimenzijeIzmenjene = false;
  // let stariModul = terUtilsSelectModulBySubkey(subkey, state.draftel_arr);
  let stariModul = _smartbom_manipulator_get_draftel_single_by_subkey(state.smartbom, subkey);
  let noviModul = entbox;
  console.log(typeof stariModul.duzinamodula, typeof noviModul.duzinamodula)
  if (stariModul.duzinamodula !== noviModul.duzinamodula) {
    dimenzijeIzmenjene = true;
  }
  if (stariModul.kojavelicina !== noviModul.kojavelicina) {
    dimenzijeIzmenjene = true;
  }
  if (stariModul.flag_dimenzijemodulaunc !== noviModul.flag_dimenzijemodulaunc) {
    dimenzijeIzmenjene = true;
  }
  if (stariModul.sirinamodulaunc !== noviModul.sirinamodulaunc) {
    dimenzijeIzmenjene = true;
  }
  if (stariModul.visinamodulaunc !== noviModul.visinamodulaunc) {
    dimenzijeIzmenjene = true;
  }
  // TODO: ..nastaviti dalje sa svim poljima koji su za dimenzije na isti nacin
  /*
  {
    "siframodula": "AHUM1",
    "brojmodula": 1,
    "kojavelicina": "1",
    "duzinamodula": 400,
    "subkey": "109",
    "parent_subkey": "113",
    "superkey": 104,
    "brojkomadaprofilpregradnisirinski": 123,
    "brojkomadaprofilpregradnivisinski": 456,
    "sirinakomoreunc": 1,
    "visinamodulaunc": 2
  }
  */

  if (dimenzijeIzmenjene) {
    // ako su dimenzijeizmenjene
    zaSupervalidatorDimenzijeModulaIzmenjene = freshness;
  }
  // kraj provere


  let wizardInfo = {
    operationFreshness: wizardOperationFreshness,
    operationCreatedId: false,
    what: 'MODUL'
  };
  if (wizardMode === true) {
    // TODO: ne znamo da li ovo treba u EDIT modu ???
    // ukoliko je element dodat u wizard modu, njegov subkey se belezi u draft state kako bi wizard mogao da ga koristi za sledece korake
    // wizardInfo.operationCreatedId = newDraftel.subkey;
    wizardInfo.operationCreatedId = subkey;
  }

  return {
    ...state,
    smartbom: _smartbom_manipulator_update_draftel(state.smartbom, subkey, editedDraftel, _draftel_codecs_datarender_virbom_from_single_draftel),
    // draftel_arr: draftel_arr_utils_item_update(state.draftel_arr, subkey, editedDraftel),
    saved: false,
    virbom_header: false,
    virtel_with_genus_ident_arr: null,
    wizardInfo: wizardInfo,
    freshness: freshness,
    zaSupervalidatorDimenzijeModulaIzmenjene: zaSupervalidatorDimenzijeModulaIzmenjene
  };
};


export const terUtilsUpdatePoluproizvodHelper = (state, entbox, subkey) => {
  // REDUCER HELPER - TREBA PAZITI DA BUDE PURE I SVI UTILS...
  let editedDraftel = {
    ...entbox,
    subkey: subkey
  }
  return {
    ...state,
    smartbom: _smartbom_manipulator_update_draftel(state.smartbom, subkey, editedDraftel, _draftel_codecs_datarender_virbom_from_single_draftel),
    // draftel_arr: draftel_arr_utils_item_update(state.draftel_arr, subkey, editedDraftel),
    saved: false,
    virbom_header: false,
    virtel_with_genus_ident_arr: null,
    freshness: counter.getFreshInteger()
  };
};


//
export const terUtilsUpdateSmartelEnabled = (state, enabled, subkey) => {
  // NOVO
  return {
    ...state,
    smartbom: _smartbom_manipulator_update_draftel_enabled(state.smartbom, subkey, enabled),
    freshness: counter.getFreshInteger()
  };
};


//
export const terUtilsUpsertSmartelSelfProperty = (state, keyVal, subkey) => {
  // NOVO
  return {
    ...state,
    smartbom: _smartbom_manipulator_upsert_self_property(state.smartbom, subkey, keyVal, _draftel_codecs_datarender_virbom_from_single_draftel),
    freshness: counter.getFreshInteger()
  };
};


// POZICIJA MODULA

export const terUtilsUpdateKlimaKomoraPozicijaModulaHelper = (state, payload) => {
  let modul_subkey = payload.modul_subkey;
  let m = terUtilsSelectModulBySubkey(modul_subkey, state.draftel_arr);
  let k = terUtilsSelectKlimaKomoraBySubkey(m.parent_subkey, state.draftel_arr)
  let pozicijemodula = k.pozicijemodula;
  // KORAK 1 brisnje zadatog modula iz bilo koje prethodne pozicije
  let novePozicijeModula1 = terUtilsPozicijeModulaDeletePozicijaWhere(pozicijemodula, modul_subkey);
  // KORAK 2 upis zadatog modula na zadatu poziciju
  let novePozicijeModula = terUtilsPozicijeModulaUpdatePozicijaWhere(novePozicijeModula1, modul_subkey, payload.broj);
  // edited KlimaKomora item
  let editedDraftel = {
    ...k,
    pozicijemodula: novePozicijeModula,
    subkey: k.subkey
  }
  return {
    ...state,
    // draftel_arr: draftel_arr_utils_item_update(state.draftel_arr, k.subkey, editedDraftel),
    saved: false,
    virbom_header: false,
    virtel_with_genus_ident_arr: null,
    freshness: counter.getFreshInteger()
  };
};


const terUtilsPozicijeModulaCreateSveBlank = () => {
  // NOVO 2021april
  // novi format ima 12 pozicija odvojenih sa 11 zareza koji uvek moraju da budu
  const DELIMETER = COMMA; // ','
  const pozicijemodula = DELIMETER.repeat(11);
  return pozicijemodula;
};
export const _pozicijeModulaCSVToArr = (csv_simple) => {
  let arr = [];
  if (typeof csv_simple === 'string') {
    arr = csv_simple.split(COMMA);
  }
  if (arr.length < 12) {
    const _kolikoJosTreba = 12 - arr.length;
    for (let i = 0; i < _kolikoJosTreba; i++) {
      arr.push('');
    }
  }
  return arr;
};
export const _pozicijeModulaArrToCSV = (pozicijeArr) => {
  let csv_simple = '';
  for (let i = 0; i < 12; i++) {
    let pos = '';
    if (pozicijeArr[i]) {
      pos = pozicijeArr[i]
    }
    csv_simple += pozicijeArr[i];
    if (i < 11) {
      csv_simple += COMMA;
    }
  }
  return csv_simple;
};
export const terUtilsPozicijeModulaDeletePozicijaWhere = (pozicijemodula, modul_subkey) => {
  // brisanje pozicije modula gde je upisan taj subkey modula
  // console.log('brisanje ***', modul_subkey);
  // NOVO 2021april
  const pozicijeArr = _pozicijeModulaCSVToArr(pozicijemodula);
  const novePozicijeModulaArr = pozicijeArr.map((pos) => {
    if (pos && pos === modul_subkey && modul_subkey) {
      return ''; // obrisana pozicija je prazan string ''
    }
    return pos;
  });
  const novePozicijeModula = _pozicijeModulaArrToCSV(novePozicijeModulaArr);
  return novePozicijeModula;
};
export const terUtilsPozicijeModulaUpdatePozicijaWhere = (pozicijemodula, modul_subkey, broj) => {
  // upis modul subkey na odredjenu poziciju modula
  // NOVO 2021april
  const pozicijeArr = _pozicijeModulaCSVToArr(pozicijemodula);
  const novePozicijeModulaArr = pozicijeArr.map((pos, index) => {
    const target_index = broj - 1;
    if (index === target_index) {
      // target position
      let newPos = '';
      try {
        newPos = modul_subkey.toString();
      } catch (err) {
        //
      }
      return newPos; // novi upis na poziciju
    }
    return pos;
  });
  const novePozicijeModula = _pozicijeModulaArrToCSV(novePozicijeModulaArr);
  return novePozicijeModula;
};
export const terUtilsPozicijeModulaUpdatePozicionirajAutomatski = (pozicijemodula, modul_subkey) => {
  // upis modul subkey na odredjenu poziciju modula
  // NOVO 2021april
  let _vecPozicionirano = false;
  const pozicijeArr = _pozicijeModulaCSVToArr(pozicijemodula);
  // console.log(pozicijeArr);
  const novePozicijeModulaArr = pozicijeArr.map((pos, i) => {
    if (_vecPozicionirano === true) {
      return pos; // zadrzavamo prethodni upis
    }
    // console.log(pos, i, pos === '');
    if (pos === '') {
      let newPos = modul_subkey.toString();
      _vecPozicionirano = true;
      return newPos; // novi upis na poziciju
    } else {
      return pos; // zadrzavamo prethodni upis
    }

  });
  const novePozicijeModula = _pozicijeModulaArrToCSV(novePozicijeModulaArr);
  return novePozicijeModula;
};

